<!--
  File name: ReportsAsir.vue
  Program Description:
    - View page for Asir Reports
    - Contains bar graph and pie graph for Total no. of Incident Report per Sector and Total no. of submitted Incident Reports
-->
<template>
  <v-container>
    <v-row>
      <v-col>
        <h1>ASIR Reports</h1>
      </v-col>
      <v-col
        cols="2"
        class="d-flex justify-center"
      >
        <ExportDropdown
          :collection="'asir'"
          :dataset="[IRperYearData, IRperSectorData, IRperOrgData, IRperSubsectorData]"
          :chart-format="[!!toggleButtonValue]"
          :filtered-asir-data="{ filteredYear, filteredAsirs}"
          :selected-years="years"
          :loading="loading"
          :sector-toggle-value="sectorToggleValue"
          :disabled="userRoleIs('pic') ? !showGraphYear : !showGraph && !showGraphYear"
        />
      </v-col>
    </v-row>
    <v-row v-if="!userRoleIs('pic')">
      <v-col cols="8">
        <ReportCard
          v-if="!loading"
          #default="{ sectorToggleButton }"
          v-model="reportCardButtons"
          :show-subsector="sectors.length > 0"
          title="Total no. of Incident Report per Sector"
          can-toggle-sector
          toggle
        >
          <template v-if="sectorToggleButton.includes(0)">
            <Chart
              v-if="showGraph"
              :class="toggleButtonValue === 1 ? '': 'pt-6'"
              :chart-data="IRperSectorData"
              :chart-type="toggleButtonValue === 1 ? 'pie' : 'bar'"
              :chart-options="toggleButtonValue === 1 ? graphOptions.pieOptions : graphOptions.barOptions"
              :canvas-height="toggleButtonValue === 1 ? '400px' : '600px'"
              label="Sector"
            />
            <template v-else>
              <h2 class="text-center grey--text text-h6 my-4">
                Sector
              </h2>
              <NoDataYet
                :image="implem"
                class="mt-12"
                message="No data yet"
              />
            </template>
          </template>
          <template v-if="sectorToggleButton.includes(1) && sectors.length > 0">
            <Chart
              v-if="showGraph && showSubsector"
              :class="toggleButtonValue === 1 ? '': 'pt-6'"
              :chart-data="IRperSubsectorData"
              :chart-type="toggleButtonValue === 1 ? 'pie' : 'bar'"
              :chart-options="toggleButtonValue === 1 ? graphOptions.pieOptions : graphOptions.barOptions"
              :canvas-height="toggleButtonValue === 1 ? '400px' : '600px'"
              label="Subsector"
            />
            <template v-else>
              <h2 class="text-center grey--text text-h6 my-4">
                Subsector
              </h2>
              <NoDataYet
                :image="implem"
                class="mt-12"
                message="No data yet"
              />
            </template>
          </template>
        </ReportCard>
        <ReportCard
          v-else
          title="Total no. of Incident Report per Sector"
          toggle
        >
          <div
            style="width: 100%; min-height: 500px"
            class="d-flex justify-center align-center"
          >
            <v-progress-circular
              indeterminate
              color="primary"
            />
          </div>
        </ReportCard>
      </v-col>
      <v-col
        cols="4"
        class="pa-0"
      >
        <FilterAsir
          v-model="filteredAsirs"
          :asirs="asirs"
          @update:sectors="val => sectors = val"
        />
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col :cols="userRoleIs('pic') ? '12': '8'">
        <ReportCard
          v-if="!loading"
          v-model="reportCardButtons"
          title="How Incidents Occur per year"
          :toggle="userRoleIs('pic')"
        >
          <FilterAsir
            v-model="filteredYear"
            year-only
            class="pl-12"
            :asirs="asirs"
            :default-year="defaultYear"
            @yearChange="val => years = [...val].sort()"
          />
          <Chart
            v-if="showGraphYear"
            :id="userRoleIs('pic') ? 'IRperYearData' : 'IRperOrgData'"
            :class="toggleButtonValue === 1 || !userRoleIs('pic') ? '' : 'px-12'"
            :chart-data="userRoleIs('pic') ? IRperYearData : IRperOrgData"
            :chart-type="toggleButtonValue === 1 || !userRoleIs('pic') ? 'pie' : 'bar'"
            :chart-options="toggleButtonValue === 1 || !userRoleIs('pic') ? graphOptions.pieOptions : graphOptions.barOptions"
            :canvas-height="toggleButtonValue === 1 && userRoleIs('pic') ? '200px' : '450px'"
            custom-design
          />
          <NoDataYet
            v-else
            :image="implem"
            class="mt-12"
            message="No data yet"
          />
        </ReportCard>
        <ReportCard
          v-else
          :title="`Total no. of submitted Incident Report${userRoleIs('pic') ? 's' : ' per Organization'}`"
          :toggle="userRoleIs('pic')"
        >
          <div
            style="width: 100%; min-height: 500px"
            class="d-flex justify-center align-center"
          >
            <v-progress-circular
              indeterminate
              color="primary"
            />
          </div>
        </ReportCard>
      </v-col>
    </v-row>
    <div
      v-show="!!tooltip"
      :style="{
        position: 'absolute',
        ...tooltipStyle,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        padding: '10px'
      }"
    >
      <span style="color: white">{{ tooltip }}</span>
    </div>
  </v-container>
</template>

<script>
import crud from '@/utils/rest/crud'
import implem from '@/assets/implem.png'
import graphOptions from '@/meta/graphOptions'
import ReportCard from '@/components/ReportCard'
import Chart from '@/components/exports/charts/Chart.vue'
import ExportDropdown from '@/components/exports/ExportDropdown'
import FilterAsir from '@/components/exports/charts/FilterAsir.vue'
export default {
  name: 'ReportAsir',
  components: {
    ExportDropdown,
    ReportCard,
    FilterAsir,
    Chart
  },
  data: () => ({
    filteredAsirs: [],
    filteredYear: [],
    years: [],
    asirs: [],
    sectors: [],
    tooltip: '',
    tooltipStyle: {
      left: 0,
      top: 0
    },
    isPie: false,
    loading: false,
    init: true,
    reportCardButtons: {
      sectorToggleButton: [0, 1],
      toggleButton: 0
    },
    voluntary: 0,
    mandatory: 0,
    incidents: {
      communicationFailure: 'Communication Failure',
      designError: 'Design Error',
      hacking: 'Hacking',
      hardwareFailure: 'Hardware Failure',
      identityFraud: 'Identity Fraud',
      maliciousCode: 'Malicious Code',
      misuseOfResources: 'Misuse of Resources',
      naturalDisaster: 'Natural Disaster',
      operationsError: 'Operations Error',
      others: 'Others',
      sabotage: 'Sabotage/Physical Damage',
      softwareFailure: 'Software Failure',
      softwareMaintenanceError: 'Software Maintenance Error',
      theft: 'Theft',
      thirdParty: 'Third Party/Service Provider',
      userError: 'User Error'
    }
  }),
  computed: {
    // data is formatted for IR per year
    IRperYearData () {
      const IRperYear = {}
      if (!this.filteredYear) return []
      for (const asir of this.filteredYear) {
        const total = parseInt(asir.summary.total)
        const prevTotal = parseInt(IRperYear[`${asir.year}`] || 0)
        IRperYear[`${asir.year}`] = prevTotal + total
      }
      const maxBarThickness = 100
      return this.convertToGraphData(IRperYear, maxBarThickness)
    },
    // data is formatted for Incidents Occur per year
    IRperOrgData () {
      if (!this.filteredYear) return []
      const IRperOrg = {}
      const ignore = ['mandatoryBreachReported', 'specify']
      for (const asir of this.filteredYear) {
        const asirIncidents = asir.securityIncidentsOccured
        for (const [key, value] of Object.entries(asirIncidents)) {
          if (ignore.includes(key)) continue
          const label = this.incidents[`${key}`]
          const prevTotal = parseInt(IRperOrg[`${label}`] || 0)
          IRperOrg[`${label}`] = prevTotal + value
        }
      }
      const extraData = { voluntary: this.voluntary, mandatory: this.mandatory }
      return this.convertToGraphData(IRperOrg, 70, extraData)
    },
    // data is formatted for IR per sector
    IRperSectorData () {
      const IRperSector = {}
      if (!this.filteredAsirs) return []
      for (const asir of this.filteredAsirs) {
        const prevTotal = parseInt(IRperSector[`${asir.sectorName.value}`] || 0)
        IRperSector[`${asir.sectorName.value}`] = prevTotal + 1
      }
      const maxBarThickness = 70
      return this.convertToGraphData(IRperSector, maxBarThickness)
    },
    IRperSubsectorData () {
      const IRperSubsector = {}
      if (!this.filteredAsirs) return []
      for (const asir of this.filteredAsirs) {
        if (asir.subSectorName.length === 0) continue
        const prevTotal = parseInt(IRperSubsector[`${asir.subSectorName[0].value}`] || 0)
        IRperSubsector[`${asir.subSectorName[0].value}`] = prevTotal + 1
      }
      const maxBarThickness = 70
      return this.convertToGraphData(IRperSubsector, maxBarThickness)
    },
    showSubsector () {
      return this.IRperSubsectorData.labels.length > 0
    },
    showGraphYear () {
      return (this.filteredYear && this.filteredYear.length !== 0) || this.init
    },
    showGraph () {
      return (this.filteredAsirs && this.filteredAsirs.length !== 0) || this.init
    },
    defaultYear () {
      return this.userRoleIs('pic') ? 0 : (new Date()).getFullYear() - 1
    },
    graphOptions () {
      return graphOptions('asir', this)
    },
    implem () {
      return implem
    },
    userRole () {
      return this.$s && this.$s.userRole
    },
    userId () {
      return this.$s && this.$s.user
    },
    userRoleIs () {
      return role => this.userRole && this.userRole.includes(role)
    },
    toggleButtonValue () {
      return this.reportCardButtons.toggleButton
    },
    sectorToggleValue () {
      if (!this.sectors.length) return [0]
      return this.reportCardButtons.sectorToggleButton
    }
  },
  async created () {
    // triggers when the page is loaded
    // gets asir list
    // if pic, only get own created asir, else get all
    this.loading = true
    const advancedQuery = { status: { $ne: 'Drafted' } }
    if (this.userRoleIs('pic')) advancedQuery.createdBy = { $eq: this.userId }
    const asirs = await crud('graph/asir').list({ advancedQuery })
    this.asirs = asirs.entries
    this.filteredYear = asirs.entries
    if (!this.userRoleIs('pic')) this.filteredAsirs = asirs.entries
    for (const asir of asirs.entries) {
      this.voluntary += asir.summary.voluntaryBreachNotification
      this.mandatory += asir.summary.mandatoryBreachNotification
    }
    this.init = false
    this.loading = false
  },
  methods: {
    // formatting of data to chartData
    convertToGraphData (dataObject, maxBarThickness, extra) {
      const labels = Object.keys(dataObject)
      const data = Object.values(dataObject)
      const fill = false
      const backgroundColor = this.graphOptions.graphColors
      const datasets = [{ data, fill, maxBarThickness, backgroundColor }]
      const extraData = extra || { labels }
      return { datasets, labels, extraData }
    }
  }
}
</script>

<style scoped>
.hide-graph{
  position: absolute;
  top: -9999px;
  left:-9999px;
  z-index: -9999;
  visibility:hidden;
}
</style>
